import gql from 'graphql-tag'

export const LIST_GROUPS = gql`
  query ListGroupsQuery($limit: Int!, $offset: Int!, $orderBy: String!, $isDelete: Float!){
    listGroups(orderBy: $orderBy){
      results(limit: $limit, offset: $offset){
        id
        name
        profiles(isDelete: $isDelete){
          id
        }
      }      
      totalCount
    }
  } 
`

export const LIST_QUERY_GROUPS = gql`
  query ListGroupsQuery($limit: Int!, $offset: Int!, $orderBy: String!, $name: String!){
    listGroups(name_Icontains:$name, orderBy: $orderBy){
      results(limit: $limit, offset: $offset){
        id
        name
      }      
      totalCount
    }
  } 
`

export const LIST_GROUP_CONTACTS_WITH_WORK = gql`
  query ListGroupContactsQuery($limit: Int!, $offset: Int!, $groupId: Float!, $orderBy: String!, $profileIsDelete: Float!){ 
    listGroupProfile(groupId: $groupId, orderBy: $orderBy, profileIsDelete: $profileIsDelete){
      results(limit: $limit, offset: $offset){
        profile{
          id
          number
          name
          lastName
          avatarImg
          gender
          facebookUrl
          instagramUrl
          lastSmsBody
          hasUnread
          pendingStatus
          profileWorkHistory{
            id
            organization{
              id
              name
            }
            title{
              id
              name
            }                     
          }
        }
      }
      totalCount
    }
  }
`

export const LIST_EDIT_GROUP_CONTACTS = gql`
  query ListGroupContactsQuery($limit: Int!, $offset: Int!, $groupId: Float!, $orderBy: String!, $profileIsDelete: Float!){ 
    listGroupProfile(groupId: $groupId, orderBy: $orderBy, profileIsDelete: $profileIsDelete){
      results(limit: $limit, offset: $offset){
        profile{
          id
          number
          name
          lastName
          avatarImg
          gender
          facebookUrl
          instagramUrl
          birthyear
          description
          categorySet{
            id
            name
          }
          groupSet{
            id
            name
          }
          bdayTags (name: "birthday"){
            id
            intValue
            strValue
            name
          }
          profileWorkHistory{
            id
            organization{
              id
              name
            }
            title{
              id
              name
            }                     
          }
        }
      }
      totalCount
    }
  }
`
